import { Project } from "../../../../types/project/project";
import { Resume } from "../../../../types/resume/resume";

export function generateJapaneseResume(projects: Project[] | undefined): Resume {
  const resume: Resume = {
    name: "Colby Birkhead",
    title: "フルスタックエンジニア",
    contact: {
      phone: '+82-10-6501-5021',
      email: 'birkheadc@gmail.com',
      websites: [
        {
          name: 'birkheadc.me',
          url: 'https://birkheadc.me'
        },
        {
          name: 'linkedin.com/in/colby-birkhead',
          url: 'https://linkedin.com/in/colby-birkhead'
        },
        {
          name: 'github.com/birkheadc',
          url: 'https://github.com/birkheadc'
        },
        {
          name: 'facebook.com/colby.birkhead',
          url: 'https://facebook.com/colby.birkhead'
        }
      ]
    },
    introduction: 'フルスタックエンジニア・スタートアップ最高技術責任者(CTO)。SEOツール、業務用ダッシュボード、社内ツールなど、幅広い分野でのソフトウェア開発実務経験を持つ。CTOとしては、レガシーアプリケーションの刷新から新規開発まで、長期的なロードマップの策定・統括を担当。設計からクラウドデプロイまで、プロジェクトを一貫して担当可能。新しい環境への適応力が高く、変化の中でチームを牽引することを得意とする。アメリカ出身、英語・日本語ともに流暢、韓国語は日常会話レベル。',
    sections: [
      {
        name: '職歴',
        items: [
          {
            date: {
              from: '2025年',
            },
            title: "最高技術責任者(CTO)",
            bulletPoints: [
              "アプリケーション開発全体を統括し、技術リソースのマネジメントを担当",
              "社内ツールを刷新する8ヶ月間のロードマップを統括・完遂し、経営陣の関連業務の73.7%を自動化",
              "設計・プロトタイピング・デモから実装・テストまで、開発プロセス全体にAIファーストのワークフローを導入",
            ]
          },
          {
            date: {
              from: '2024年',
              to: '2025年'
            },
            title: "ウェブ開発エンジニア",
            bulletPoints: [
              "小規模企業向けのソーシャルメディア管理・分析ツールを開発",
              "GoogleやInstagramなど複数のサードパーティAPIとの連携を担当",
              "数百万件規模のレコードを処理するETLデータパイプラインを、サービスを停止させることなく改修",
            ]
          },
          {
            date: {
              from: '2017年',
              to: '2024年'
            },
            title: '小売店店主',
            bulletPoints: [
              "外国人向けスーパーの経営",
              "日常業務を支援するアプリケーションを複数開発。その一つに、かつて年間100時間以上を要していた作業を自動化した簿記アプリケーションがある"
            ]
          }
        ]
      },
      {
        name: '学歴',
        items: [
          {
            date: {
              from: '2013年',
              to: '2017年'
            },
            title: '名古屋大学',
            bulletPoints: [
              "文学部言語学専攻卒業(文学士) / 文部科学省(MEXT)奨学金による国費留学生",
            ]
          }
        ]
      },
      {
        name: '個人プロジェクト',
        items: projects ? projects.sort((a, b) => b.resumeFavoriteLevel - a.resumeFavoriteLevel).slice(0, 2).map(
          project =>
          ({
            title: project.title,
            bulletPoints: project.descriptions.bulletPoints.find(bp => bp.language === 'ja')?.content ?? [],
            site: project.site,
            source: project.source
          })
        ) : []
      },
      {
        name: 'スキル',
        items: [
          {
            title: "フルスタック開発",
            bulletPoints: [
              "得意な技術: モダンなTypeScript, React, Node, NestJS, PostgreSQL, クラウドデプロイ(AWS)",
              "その他の経験: HTML5, CSS, Angular, C# / ASP.NET, Java / Spring, Ruby / Rails, MySQL, SQLite, MongoDB, DynamoDB",
              "周辺技術・ツール: Linux, Bash, Git, Docker"
            ]
          },
          {
            title: "ゲーム開発",
            bulletPoints: [
              "itch.ioでのゲームジャムに複数回参加し、作品を公開",
            ]
          },
          {
            title: "言語",
            bulletPoints: [
              "英語: 母語",
              "日本語: 学習歴15年以上、流暢",
              "韓国語: 学習歴5年以上、日常会話レベル"
            ]
          }
        ]
      }
    ]
  }

  return resume;
}